// DS: MO0.4
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import SaleIcon from '@wix/da-ds/pkg/Icons/16x16/Sale';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import FolderShopCard from '../../../../ShopCard/FolderShopCard';
import { ResourceType } from '../../../../types/resource';
import UserAvatar from '../../../../User/Avatar';
import { DeviationTypes } from '../../../../types/deviation';
import TierPromotionCard from '../../../../DeviationViews/TierPromotionCard';
import AdoptableShopCard from '../../../../ShopCard/AdoptableShopCard';
import { getDeviationEntityId } from '../../../../redux/normalizr/schemas/deviation';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import BuyCoreBrandedButton from '../../../../Button/core/dsPresets/BuyCoreBrandedButton';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import PremiumDownloadPromo from '../PremiumDownloadPromo';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import s from './MonetizationBlock.scss';
const DEFAULT_CARD_WIDTH = 308;
const MOBILE_PADDING = parseInt(s['mobile-padding'], 10);
export const MonetizationBlock = ({ block: { contentType, collections: relatedCollections, gallections: relatedGalleries, deviations: relatedDeviations }, deviation, className, biSectionPrefix })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const adopt_link_profileshop_related = useFlag('adopt_link_profileshop_related');
    const biSectionName = `${biSectionPrefix !== null && biSectionPrefix !== void 0 ? biSectionPrefix : ''}${contentType}`;
    const { ref: containerRef, dimensions: measuredContainer } = useMeasureElementCookie(undefined, {
        cookieDim: 'width'
    });
    const cardWidthMobile = measuredContainer ? measuredContainer.width - MOBILE_PADDING * 2 : DEFAULT_CARD_WIDTH;
    if ((contentType === 'monetization_promotion_premium_gallery_firstparty' || contentType === 'monetization_promotion_premium_gallery_thirdparty') && relatedGalleries && relatedGalleries.length) {
        const relatedGallection = relatedGalleries[0].gallection;
        const { isPremium } = normalizePremiumFolderData(relatedGallection === null || relatedGallection === void 0 ? void 0 : relatedGallection.premiumFolderData);
        if (relatedGallection && isPremium) {
            return /*#__PURE__*/ React.createElement("div", {
                className: c(className, s['root']),
                ref: containerRef
            }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
                value: {
                    sectionname: biSectionName
                }
            }, /*#__PURE__*/ React.createElement(FolderShopCard, {
                width: isMobile ? cardWidthMobile : DEFAULT_CARD_WIDTH,
                folder: relatedGallection,
                withIndicators: false,
                withUnlockButton: true,
                linkToShop: true
            })));
        }
    }
    if (relatedDeviations && relatedDeviations.length) {
        const relatedDeviation = relatedDeviations[0];
        if (relatedDeviation.type === DeviationTypes.TIER) {
            const tierEntityId = getDeviationEntityId(relatedDeviation);
            const biData = BiData({
                evid: 547,
                typeid: relatedDeviation.typeId,
                itemid: relatedDeviation.deviationId,
                referral_info: ReferralType.SIDEBAR_PROMOTION,
                page_itemid: deviation.deviationId,
                page_typeid: getDeviationResourceType(deviation),
                sectionname: biSectionName,
                section_typeid: ResourceType.DEVIATION
            });
            return /*#__PURE__*/ React.createElement("div", {
                ref: containerRef,
                className: c(className, s['root'], s['tier-card-root'])
            }, /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.userSubscriptionsDeeplink({
                    username: relatedDeviation.author.username,
                    tierEntityId
                }),
                className: s['link'],
                biData: biData
            }), /*#__PURE__*/ React.createElement(TierPromotionCard, {
                width: isMobile ? cardWidthMobile : DEFAULT_CARD_WIDTH,
                verticalLayout: true,
                deviation: relatedDeviation
            }));
        } else if (relatedDeviation.isAdoptable) {
            let link = Url.userShopPath(relatedDeviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.EXCLUSIVES);
            if (adopt_link_profileshop_related) {
                link = Url.userShopLink(relatedDeviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.EXCLUSIVES, {
                    deviationid: `${contentType !== 'monetization_promotion_adoptable_generic' ? relatedDeviation.deviationId : deviation.deviationId}`
                });
            }
            return /*#__PURE__*/ React.createElement("div", {
                className: c(className, s['root']),
                ref: containerRef
            }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
                value: {
                    sectionname: biSectionName
                }
            }, /*#__PURE__*/ React.createElement(AdoptableShopCard, {
                width: isMobile ? cardWidthMobile : DEFAULT_CARD_WIDTH,
                deviation: relatedDeviation,
                overrideHref: link,
                withIndicators: false,
                footerSlot: /*#__PURE__*/ React.createElement(BuyButton, {
                    isFakeButton: true,
                    tabIndex: -1,
                    icon: SaleIcon,
                    size: "medium",
                    fillContainerWidth: true,
                    rounded: true
                }, t('sidebar.monetizationBlock.var.exclusive.CTA'))
            })));
        }
    }
    let type;
    let link;
    let biData;
    const commonBiData = {
        typeid: deviation.typeId,
        itemid: deviation.deviationId,
        referral_info: ReferralType.SIDEBAR_PROMOTION,
        sectionname: biSectionName,
        section_typeid: ResourceType.DEVIATION
    };
    if (contentType === 'monetization_promotion_tier' || contentType === 'monetization_promotion_tier_firstparty' || contentType === 'monetization_promotion_tier_generic' || contentType === 'monetization_promotion_tier_thirdparty' || contentType === 'subscription_promotion' /* backwards compatibility */ ) {
        type = 'tier';
        link = Url.userSubscriptionsPath({
            username: deviation.author.username
        });
        biData = BiData(_object_spread({
            evid: 547
        }, commonBiData));
    } else if (contentType === 'monetization_promotion_adoptable' || contentType === 'monetization_promotion_adoptable_firstparty' || contentType === 'monetization_promotion_adoptable_thirdparty' || contentType === 'monetization_promotion_adoptable_generic') {
        type = 'adoptable';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.EXCLUSIVES);
        biData = BiData(_object_spread({
            evid: 546
        }, commonBiData));
    } else if (contentType === 'monetization_promotion_premium_gallery' || contentType === 'monetization_promotion_premium_gallery_generic') {
        type = 'premium_gallery';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
        biData = BiData(_object_spread({
            evid: 549
        }, commonBiData));
    } else if (contentType === 'monetization_promotion_commission' || contentType === 'monetization_promotion_commission_generic') {
        type = 'commission';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
        biData = BiData(_object_spread({
            evid: 548
        }, commonBiData));
    } else if (contentType === 'monetization_promotion_pcp_firstparty' || contentType === 'monetization_promotion_pcp_thirdparty') {
        var _firstDeviation_author;
        const firstDeviation = (relatedDeviations || []).find(Boolean);
        const authorUsername = firstDeviation === null || firstDeviation === void 0 ? void 0 : (_firstDeviation_author = firstDeviation.author) === null || _firstDeviation_author === void 0 ? void 0 : _firstDeviation_author.username;
        const deviationId = firstDeviation === null || firstDeviation === void 0 ? void 0 : firstDeviation.deviationId;
        const shopPremiumDownloadsUrl = authorUsername && deviationId ? Url.userShopLink(authorUsername, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT, {
            deviationid: deviationId.toString()
        }) : undefined;
        return /*#__PURE__*/ React.createElement("div", {
            className: c(className, s['root']),
            ref: containerRef
        }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                sectionname: biSectionName
            }
        }, /*#__PURE__*/ React.createElement(PremiumDownloadPromo, {
            deviations: relatedDeviations,
            width: isMobile ? cardWidthMobile : DEFAULT_CARD_WIDTH,
            overrideHref: shopPremiumDownloadsUrl
        })));
    } else if (contentType === 'monetization_promotion_pcp' || contentType === 'monetization_promotion_pcp_generic') {
        type = 'pcp';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT);
        biData = BiData(_object_spread({
            evid: 557
        }, commonBiData));
    } else if (contentType === 'monetization_promotion_core_generic') {
        type = 'core';
        link = Url.coreMembershipLink();
        biData = BiData(_object_spread({
            evid: 375
        }, commonBiData));
    } else {
        return null;
    }
    if (!deviation.author) {
        return null;
    }
    if (type === 'core') {
        return /*#__PURE__*/ React.createElement("div", {
            className: c(className, s['root'], s['core-upsell'])
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['heading']
        }, t(`sidebar.monetizationBlock.var.core.heading`)), /*#__PURE__*/ React.createElement("div", {
            className: s['text']
        }, t(`sidebar.monetizationBlock.var.core.body`)), /*#__PURE__*/ React.createElement(BuyCoreBrandedButton, {
            size: "medium",
            biData: biData
        }, t(`sidebar.monetizationBlock.var.core.CTA`)));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className, s['root'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['content'], s[`type-${type}`])
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        className: s['avatar'],
        user: deviation.author,
        withTooltip: false,
        size: 40,
        relatedItemBiData: {
            typeid: deviation.typeId,
            itemid: deviation.deviationId
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`sidebar.monetizationBlock.var.${type}.body`)), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['btn-subscribe'],
        href: link,
        biData: biData
    }, t(`sidebar.monetizationBlock.var.${type}.CTA`))));
};
MonetizationBlock.displayName = 'MonetizationBlock';
export default MonetizationBlock;

//# sourceMappingURL=MonetizationBlock.js.map